import {
  CircleDollarSign,
  CreditCard,
  ReceiptText,
  WalletCards,
} from 'lucide-react';

export const billingSecondarySidebar = {
  enabled: true,
  title: 'امور مالی',
  items: [
    {
      id: 'subscription',
      label: 'پلن و اشتراک',
      icon: CreditCard,
      path: '/subscription',
      description: 'ظرفیت، افزونه‌ها و تمدید پلن',
      activePaths: ['/subscription'],
    },
    {
      id: 'credit',
      label: 'اعتبار',
      icon: WalletCards,
      path: '/credit',
      description: 'شارژ و گردش اعتبار',
      activePaths: ['/credit'],
    },
    {
      id: 'invoices',
      label: 'فاکتورها',
      icon: ReceiptText,
      path: '/invoices',
      description: 'پرداخت‌ها و سوابق مالی',
      activePaths: ['/invoices'],
    },
    {
      id: 'payments',
      label: 'تراکنش‌ها',
      icon: CircleDollarSign,
      path: '/payments',
      description: 'وضعیت تلاش‌های پرداخت',
      activePaths: ['/payments'],
    },
  ],
};
